import React from 'react';
import PropTypes from 'prop-types';

import Card from '@pattern-library/card';

const propTypes = {
    userPlans: PropTypes.arrayOf(
        PropTypes.shape({
            IID: PropTypes.number,
            PlanID: PropTypes.string,
            PlanName: PropTypes.string
        }).isRequired
    ).isRequired
};

// converts each word to Title Case unless it matches one of the ignoredStrings
function toTitleCase(str) {
    const ignoredStrings = ['LLC'];
    return str.replace(/\w\S*/g, txt =>
        ignoredStrings.includes(txt)
            ? txt
            : txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
    );
}

function PlanSelector(props) {
    const { userPlans } = props;

    return (
        <React.Fragment>
            <div className="text--center">
                <span className="asc-icon asc-icon--briefcase mfa-header-icon">
                    <span className="asc-acc-hidden">briefcase icon</span>
                </span>
            </div>
            <fieldset className="asc-form-group mfa-plan-selector--form">
                <legend className="mfa-plan-selector--legend">
                    <span className="asc-heading-medium text--center">Choose a Plan</span>
                    <span className="text--center">
                        You are enrolled in multiple plans. Please choose which plan you would like
                        to login to.
                    </span>
                </legend>
                {userPlans.map(plan => (
                    <Card
                        className="mfa-plan-selector--plan-option"
                        border
                        key={plan.PlanID}
                    >
                        <span
                            className="mfa-plan-option--label"
                            id={`select-plan-${plan.PlanID}-label`}
                        >
                            {toTitleCase(plan.PlanName)}, {plan.PlanID}
                        </span>
                        <button
                            type="submit"
                            className="asc-btn asc-btn--primary"
                            name="SelectedIID"
                            aria-describedby={`select-plan-${plan.PlanID}-label`}
                            id={`select-plan-${plan.PlanID}`}
                            value={plan.IID}
                        >
                            Select
                        </button>
                    </Card>
                ))}
            </fieldset>
        </React.Fragment>
    );
}

PlanSelector.propTypes = propTypes;
export default PlanSelector;
